import { forEach } from 'ramda';

/**
 * Update all madelin toggles at once -> when a toggle gets its value modified, all of them are modified to
 * @param {*} newValue is the new value false or true ?
 * @param {*} form so we can modify all the toggles
 */
const extraMadelin = (newValue, form) => {
  const listMad = [
    'TT_CAUSE_MAD',
    'ACC_MAD',
    'RCONJ_MAD',
    'REDUC_MAD',
    'INCAP_MAD',
    'HOSP_ENF_MAD',
    'INVAL_MAD'
  ];
  forEach((mapGuarantee) => {
    if (form.watch(`guarantees.${mapGuarantee}.editable`)) {
      form.setValue(`guarantees.${mapGuarantee}.selected`, newValue);
    }
  }, listMad);
};

export default extraMadelin;
